import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { clickManagerContext } from '../../util/contextNamespace';
export default class DropdownItemClickManager extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "handleItemClicked", event => {
      this.props.onItemClicked(event);
    });
  }

  getChildContext() {
    return {
      [clickManagerContext]: {
        itemClicked: this.handleItemClicked
      }
    };
  }

  render() {
    return this.props.children;
  }

}

_defineProperty(DropdownItemClickManager, "childContextTypes", {
  // eslint-disable-next-line react/forbid-prop-types
  [clickManagerContext]: PropTypes.object
});